export function getLocalTime(time) {
  const localTime = new Date(new Date(time).getTime()).toLocaleString();

  return localTime;
}
